import { useAuth } from "@verivest/shared-components";

export { AuthContext } from "@verivest/shared-components";

export default useAuth;
